var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperiences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#616161;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36,18c0,9.9-8.1,18-18,18C8,36,0,27.9,0,18C0,8.1,8.1,0,18,0C27.9,0,36,8.1,36,18L36,18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.5,20.2c-0.2,0.6-0.8,1.1-1.5,1.1s-1.3-0.5-1.5-1.1h-6.1c-0.4,0-0.7-0.1-1.1-0.2v4c0,0.8,0.6,1.4,1.4,1.4 h14.4c0.8,0,1.4-0.7,1.4-1.4v-4c-0.3,0.2-0.7,0.2-1.1,0.2H19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.5,12.9h-3.4c-0.2-1.3-1.3-2.3-2.7-2.3h-2.8c-1.4,0-2.5,1-2.7,2.3h-3.4c-0.8,0-1.5,0.7-1.5,1.4v3.3 c0,0.8,0.6,1.4,1.4,1.4h6c0-0.4,0.2-0.8,0.5-1.1c0,0,0,0,0,0c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1 c0,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1 c0,0,0.1,0,0.1,0c0.1,0,0.1,0.1,0.2,0.2c0,0,0,0,0,0c0.3,0.3,0.5,0.6,0.5,1.1h6c0.8,0,1.4-0.6,1.4-1.4v-3.3 C27,13.5,26.3,12.9,25.5,12.9L25.5,12.9z M15.3,12.9c0.2-0.6,0.7-1,1.3-1h2.8c0.6,0,1.1,0.4,1.3,1H15.3L15.3,12.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiences);
export default __webpack_public_path__ + "static/media/experiences.6a6a00af5250957c2ceacf4a5d9b8259.svg";
export { ForwardRef as ReactComponent };